import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { browserHistory } from 'react-router';
import moment from 'moment';
import config from 'config';

export const lngs = ['en', 'ru', 'de', 'fr', 'es', 'el', 'it', 'th'];

export function isLanguage(str) {
  return lngs.indexOf(str) !== -1;
}

export function getPathLanguage(pathname) {
  const lang = pathname.split('/')[1];

  if (!lang) {
    return null;
  }

  if (!isLanguage(lang)) {
    return null;
  }

  return lang;
}

if (process.env.REACT_APP_IS_CLIENT) {
  const languageDetector = new LanguageDetector();
  languageDetector.addDetector({
    name: 'pathDetector',
    lookup: (options) => {
      const pathname = window.location.pathname;
      const lang = getPathLanguage(pathname);

      if (lang) {
        return lang;
      } else {
        return config.defaultLang || 'en';
      }
    },

    cacheUserLanguage: (lng, options) => {
      const location = browserHistory.getCurrentLocation();
      const pathname = location.pathname;
      const lang = getPathLanguage(pathname);

      if (lng && lang && (lang !== lng)) {
        const redirect = pathname.split('/').slice(2).join('/');

        browserHistory.replace({
          pathname: `/${lng}/${redirect}`,
          query: location.query
        });
      }
    }
  });

  i18n.use(languageDetector);
} else {
  const i18nMiddleware = require('i18next-express-middleware');
  i18n.use(i18nMiddleware.LanguageDetector);
}

const resources = {};

const instance = i18n.init({

  // debug: true,
  lngs: ['en', 'ru', 'de', 'fr', 'es', 'el', 'it', 'th'],
  fallbackLng: 'en',
  keySeparator: false,
  nsSeparator: false,
  resources,
  interpolation: { escapeValue: false },
  detection: {
    order: ['pathDetector', 'cookie', 'navigator', 'htmlTag'],
    lookupCookie: 'i18next',
    caches: ['pathDetector', 'cookie']
  }
});

// sync i18n locale to moment on setLanguage
instance.on('languageChanged', lng => {
  moment.locale(lng);
});

// And do it once loading on client
if (process.env.REACT_APP_IS_CLIENT) {
  moment.locale(instance.language);
}

export default instance;



// WEBPACK FOOTER //
// ./src/i18n.js